module.exports = __webpack_public_path__ + "static/media/8.e0213f2b.jpg";